console.log("[MEGA] custom.js running");
(function () {
  function addCustomOrderMenuLinks() {
    var href = '/pages/contact-us?view=custom-order#custom-order';

    var desktopMenu = document.querySelector('.menu__items');
    if (desktopMenu && !desktopMenu.querySelector('.northam-custom-order-nav')) {
      var item = document.createElement('div');
      item.className = 'menu__item child northam-custom-order-nav';
      item.setAttribute('data-nav-item', '');
      item.innerHTML = '<a href="' + href + '" data-top-link class="navlink navlink--toplevel"><span class="navtext">Custom Order</span></a>';
      desktopMenu.appendChild(item);
    }

    var mobileMenu = document.querySelector('#nav-drawer .mobile-nav');
    if (mobileMenu && !mobileMenu.querySelector('.northam-custom-order-mobile-nav')) {
      var mobileItem = document.createElement('li');
      mobileItem.className = 'mobile-menu__item mobile-menu__item--level-1 northam-custom-order-mobile-nav';
      mobileItem.innerHTML = '<a href="' + href + '" class="mobile-navlink mobile-navlink--level-1">Custom Order</a>';
      mobileMenu.appendChild(mobileItem);
    }
  }

  function findMegaFromTarget(target) {
    return target && target.closest && target.closest('.mega-2col');
  }

  function ensureDefault(mega) {
    const radios = mega.querySelectorAll('.mega-2col__toggle');
    if (!radios.length) return;

    if (!mega.querySelector('.mega-2col__toggle:checked')) {
      radios[0].checked = true;
      radios[0].dispatchEvent(new Event('change', { bubbles: true }));
      // console.log('[MEGA] default forced');
    }
  }

  function selectByHover(catEl) {
    const mega = findMegaFromTarget(catEl);
    if (!mega) return;

    const cats = mega.querySelectorAll('.mega-2col__left .mega-2col__cat');
    const radios = mega.querySelectorAll('.mega-2col__toggle');
    if (!cats.length || !radios.length) return;

    ensureDefault(mega);

    const idx = Array.prototype.indexOf.call(cats, catEl);
    if (idx >= 0 && radios[idx]) {
      radios[idx].checked = true;
      radios[idx].dispatchEvent(new Event('change', { bubbles: true }));
      // console.log('[MEGA] hover ->', idx + 1);
    }
  }

  // Runs when user moves into the mega menu: ensure first panel isn't blank
  document.addEventListener('mouseenter', (e) => {
    const mega = findMegaFromTarget(e.target);
    if (mega) ensureDefault(mega);
  }, true);

  // Hover on left category selects + stays
  document.addEventListener('mouseover', (e) => {
    const cat = e.target.closest && e.target.closest('.mega-2col__left .mega-2col__cat');
    if (cat) selectByHover(cat);
  }, true);

  // Safety: on load also try to set defaults for any already-rendered megas
  document.addEventListener('DOMContentLoaded', () => {
    addCustomOrderMenuLinks();
    document.querySelectorAll('.mega-2col').forEach(ensureDefault);
    setTimeout(() => document.querySelectorAll('.mega-2col').forEach(ensureDefault), 200);
    setTimeout(addCustomOrderMenuLinks, 400);
  });
})();

(function () {
  function pageGroup(pathname) {
    if (pathname === '/' || pathname === '') return 'home';
    if (pathname.indexOf('/products/') === 0) return 'product';
    if (pathname.indexOf('/collections/') === 0) return 'collection';
    if (pathname.indexOf('/search') === 0) return 'search';
    if (pathname.indexOf('/pages/contact-us') === 0) return 'contact';
    if (pathname.indexOf('/pages/become-a-distributor') === 0) return 'distributor';
    if (pathname.indexOf('/pages/resources') === 0 || pathname.indexOf('/blogs/') === 0) return 'resources';
    if (pathname.indexOf('/pages/') === 0) return 'page';
    return 'other';
  }

  function pushEvent(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      event: eventName,
      page_group: pageGroup(window.location.pathname),
      page_path: window.location.pathname,
      page_title: document.title
    }, payload || {}));
  }

  function linkText(link) {
    return (link.textContent || link.getAttribute('aria-label') || link.getAttribute('title') || '').replace(/\s+/g, ' ').trim();
  }

  function classifyLink(link) {
    var href = link.getAttribute('href') || '';
    var text = linkText(link);
    var lower = href.toLowerCase();

    if (lower.indexOf('tel:') === 0) return { event: 'lead_phone_click', method: 'phone' };
    if (lower.indexOf('mailto:') === 0) {
      if (lower.indexOf('partnerships@northamltd.com') !== -1 || text.toLowerCase().indexOf('distributor') !== -1 || window.location.pathname.indexOf('become-a-distributor') !== -1) {
        return { event: 'distributor_email_click', method: 'email' };
      }
      if (lower.indexOf('quote') !== -1 || text.toLowerCase().indexOf('quote') !== -1) return { event: 'quote_email_click', method: 'email' };
      return { event: 'lead_email_click', method: 'email' };
    }
    if (lower.indexOf('wa.me') !== -1 || lower.indexOf('whatsapp') !== -1) return { event: 'lead_whatsapp_click', method: 'whatsapp' };
    if (/\.pdf(\?|$)/i.test(href)) return { event: 'catalogue_download_click', method: 'pdf' };
    if (href.indexOf('/pages/contact-us') !== -1 || /quote|pricing|availability|send.*list|contact/i.test(text)) return { event: 'quote_cta_click', method: 'internal_link' };
    if (href.indexOf('/pages/become-a-distributor') !== -1 || /distributor/i.test(text)) return { event: 'distributor_cta_click', method: 'internal_link' };
    if (href.indexOf('/pages/resources') !== -1 || /catalogue|guide|resource|technical/i.test(text)) return { event: 'resource_cta_click', method: 'internal_link' };
    return null;
  }

  function selectedProductContext() {
    var title = document.querySelector('h1, .product__title')?.textContent?.trim() || '';
    var skuText = Array.from(document.querySelectorAll('body *')).map(function (node) {
      return node.childNodes.length === 1 ? node.textContent : '';
    }).find(function (value) {
      return /SKU|Item #|Product code/i.test(value || '');
    }) || '';
    return {
      product_title: title,
      product_sku_text: skuText.replace(/\s+/g, ' ').trim()
    };
  }

  function bindLeadTracking() {
    pushEvent('northam_page_group_view');

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      var classification = classifyLink(link);
      if (!classification) return;
      pushEvent(classification.event, {
        link_text: linkText(link),
        link_url: link.href,
        link_method: classification.method,
        product_context: pageGroup(window.location.pathname) === 'product' ? selectedProductContext() : undefined
      });
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.tagName || form.tagName.toLowerCase() !== 'form') return;
      var action = form.getAttribute('action') || '';
      var searchInput = form.querySelector('input[name="q"], input[type="search"]');
      if (searchInput) {
        pushEvent('site_search_submit', { search_term: searchInput.value || '' });
        return;
      }
      var formText = (form.textContent || '').toLowerCase();
      if (window.location.pathname.indexOf('become-a-distributor') !== -1 || formText.indexOf('distributor') !== -1) {
        pushEvent('distributor_form_submit', { form_action: action });
      } else if (window.location.pathname.indexOf('contact') !== -1 || formText.indexOf('contact') !== -1) {
        pushEvent('contact_form_submit', { form_action: action });
      } else {
        pushEvent('lead_form_submit', { form_action: action });
      }
    }, true);
  }

  document.addEventListener('DOMContentLoaded', bindLeadTracking);
})();

(function () {
  function setText(element, value) {
    if (!element || element.textContent.trim() === value) return;
    element.textContent = value;
  }

  function addGlobalB2BStyles() {
    if (document.querySelector('#northam-b2b-styles')) return;

    var style = document.createElement('style');
    style.id = 'northam-b2b-styles';
    style.textContent = [
      '.cart__toggle, .product-grid-item__quick-buy, .additional-checkout-buttons { display: none !important; }',
      '.product-grid-item__price, .product__price-and-badge { display: none !important; }',
      '.northam-hero-tertiary { align-self: center; color: #111111; font-weight: 700; text-decoration: underline; text-underline-offset: 4px; }',
      '.northam-product-availability-note { margin: 10px 0 0; font-size: 14px; line-height: 1.35; color: #333333; }'
    ].join('');
    document.head.appendChild(style);
  }

  function softenProductBuyingLanguage() {
    if (!/\/products\//.test(window.location.pathname)) return;

    document.querySelectorAll('[data-add-to-cart]').forEach(function (button) {
      var text = button.querySelector('[data-add-to-cart-text]') || button;
      setText(text, 'Contact for Availability');
      button.setAttribute('type', 'button');
      button.removeAttribute('name');
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var productTitle = document.querySelector('h1, .product__title')?.textContent?.trim() || document.title.replace(/\s*[–-].*$/, '');
        window.location.href = 'mailto:sales@northamltd.com?subject=' + encodeURIComponent('Quote Request: ' + productTitle);
      });
    });

    document.querySelectorAll('.product__submit__holder').forEach(function (holder) {
      if (holder.querySelector('.northam-product-availability-note')) return;
      var note = document.createElement('p');
      note.className = 'northam-product-availability-note';
      note.textContent = 'Pricing and availability are handled by the Northam team. Send the SKU or product name for a quote.';
      holder.appendChild(note);
    });
  }

  function reframeNewsletterCopy() {
    var replacements = [
      ['Sign-up for Updates', 'Northam product and catalogue updates'],
      ['Get the latest technical specifications, product releases, and stock updates.', 'Get catalogue updates, product releases, technical sheets, and distributor announcements.'],
      ['Newsletter', 'Northam Updates'],
      ['Stay up to date with the new collections, products and exclusive offers.', 'Get catalogue updates, product releases, technical sheets, and distributor announcements.'],
      ['Subscribe for Updates', 'Get Northam Updates'],
      ['Sign up', 'Get Updates']
    ];

    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      replacements.forEach(function (pair) {
        if (node.nodeValue.indexOf(pair[0]) !== -1) {
          node.nodeValue = node.nodeValue.replace(pair[0], pair[1]);
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    addGlobalB2BStyles();
    softenProductBuyingLanguage();
    reframeNewsletterCopy();
    setTimeout(reframeNewsletterCopy, 1000);
    setTimeout(softenProductBuyingLanguage, 1000);
  });
})();

(function () {
  var homePath = window.location.pathname === '/' || window.location.pathname === '';
  if (!homePath) return;

  var homeDescription = 'Northam Distributor supplies cabinet hardware, surfaces, edgebanding, glass hardware, railing hardware, fasteners, organizers, and shop supplies for manufacturers, installers, and distributors across Canada.';

  function setText(element, value) {
    if (!element || element.textContent.trim() === value) return;
    element.textContent = value;
  }

  function updateMetaDescription() {
    var meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', homeDescription);
  }

  function updateHero() {
    var heroText = Array.from(document.querySelectorAll('.slide__text.main-text span, .slide__text.main-text'))
      .find(function (element) {
        return element.textContent.trim() === 'Cabinet Accessories & Hardware';
      });
    setText(heroText, 'Hardware, surfaces, glass, railing, and shop supplies for manufacturers and installers.');

    var heroButtons = Array.from(document.querySelectorAll('.slide__buttons a'));
    heroButtons.forEach(function (button) {
      var label = button.textContent.trim();
      if (label === 'Shop All') {
        setText(button, 'Browse Product Categories');
      }
      if (label === 'Browse Products') {
        setText(button, 'Browse Product Categories');
      }
      if (label === 'Learn More') {
        setText(button, 'Request a Quote');
        button.setAttribute('href', '/pages/contact-us');
      }
    });

    var buttonsWrapper = document.querySelector('.slide__buttons');
    if (buttonsWrapper && !buttonsWrapper.querySelector('.northam-hero-tertiary')) {
      var item = document.createElement('div');
      item.className = 'main-buttons__item';
      var animatedButton = buttonsWrapper.querySelector('.main-buttons__item[data-aos]');
      if (animatedButton) {
        item.setAttribute('data-aos', animatedButton.getAttribute('data-aos') || 'fade-up');
        item.setAttribute('data-aos-anchor', animatedButton.getAttribute('data-aos-anchor') || '');
        item.setAttribute('data-aos-delay', '1000');
      }
      item.innerHTML = '<a class="northam-hero-tertiary" href="/pages/become-a-distributor">Become a Distributor</a>';
      buttonsWrapper.appendChild(item);
    }
  }

  function updateHomeCtas() {
    document.querySelectorAll('.mosaic__item__btn').forEach(function (button) {
      if (button.textContent.trim() === 'Shop Now') setText(button, 'View Products');
    });

    document.querySelectorAll('.btn--view-all').forEach(function (button) {
      var href = button.getAttribute('href') || '';
      if (href.indexOf('/collections/cabinet-handles') !== -1) {
        setText(button, 'View Cabinet Handles');
      } else if (href.indexOf('/collections/organizers') !== -1) {
        setText(button, 'View Organizers');
      } else if (button.textContent.trim() === 'Shop Now') {
        setText(button, 'View Products');
      }
    });
  }

  function addMobileCta() {
    if (document.querySelector('.northam-mobile-cta')) return;

    var style = document.createElement('style');
    style.textContent = [
      '@media screen and (max-width: 767px) {',
      'body { padding-bottom: 72px; }',
      '.northam-mobile-cta { position: fixed; right: 0; bottom: 0; left: 0; z-index: 9998; display: grid; grid-template-columns: repeat(4, 1fr); gap: 1px; padding: 8px; background: #ffffff; border-top: 1px solid rgba(0, 0, 0, 0.12); box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.12); }',
      '.northam-mobile-cta__link { display: flex; align-items: center; justify-content: center; min-height: 48px; padding: 8px 4px; border-radius: 2px; background: #193196; color: #ffffff; font-size: 12px; font-weight: 700; line-height: 1.1; text-align: center; text-decoration: none; letter-spacing: 0; }',
      '.northam-mobile-cta__link--primary { background: #701887; }',
      '}',
      '@media screen and (min-width: 768px) { .northam-mobile-cta { display: none; } }'
    ].join('');
    document.head.appendChild(style);

    var nav = document.createElement('nav');
    nav.className = 'northam-mobile-cta';
    nav.setAttribute('aria-label', 'Contact Northam');
    nav.innerHTML = [
      '<a class="northam-mobile-cta__link" href="tel:+17785642700">Call</a>',
      '<a class="northam-mobile-cta__link" href="mailto:sales@northamltd.com">Email</a>',
      '<a class="northam-mobile-cta__link" href="https://wa.me/12368639100">WhatsApp</a>',
      '<a class="northam-mobile-cta__link northam-mobile-cta__link--primary" href="/pages/contact-us">Quote</a>'
    ].join('');
    document.body.appendChild(nav);
  }

  function applyNorthamHomepageUpdates() {
    updateMetaDescription();
    updateHero();
    updateHomeCtas();
    addMobileCta();
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyNorthamHomepageUpdates();
    setTimeout(applyNorthamHomepageUpdates, 250);
    setTimeout(applyNorthamHomepageUpdates, 1000);
  });
})();
